<template>
  <div id="app">
    <header-globulo/>
    <message-dispenser />

    <transition name="fade">
      <slot></slot>
    </transition>

    <footer-globulo></footer-globulo>
    <chat-messenger />
    <organites-scene />
  </div>
</template>

<script>
  import HeaderGlobulo from '@/components/HeaderLogin'
  import FooterGlobulo from '@/components/FooterGlobulo'
  import OrganitesScene from '@/components/OrganitesScene'
  import ChatMessenger from '@/components/ChatMessenger'
  import MessageDispenser from '@/components/SideMessageDispenser'

  export default {
    components: { HeaderGlobulo, FooterGlobulo, OrganitesScene, MessageDispenser, ChatMessenger },
    computed: {
      authenticated () {
        return this.$store.state.auth.authenticated
      },
      threads () {
        return this.$store.state.threads
      }
    }
  }
</script>

<style lang="scss">
.fade-enter-active, .fade-leave-active {
  transition: opacity .6s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
   animation-name: leave;
   animation-duration: 0.8s;
}

@keyframes leave {
  from {opacity: 1;}
  to {opacity: 0;}
}
</style>
